type TProps = {
  html: string;
};
export const HTMLColumn: React.FC<TProps> = ({ html }) => {
  return (
    <div
      className="flex-grow-1"
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    ></div>
  );
};
